import { render, staticRenderFns } from "./atrTemplate.vue?vue&type=template&id=6b155f5c&scoped=true&"
import script from "./atrTemplate.vue?vue&type=script&lang=js&"
export * from "./atrTemplate.vue?vue&type=script&lang=js&"
import style0 from "./atrTemplate.vue?vue&type=style&index=0&id=6b155f5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b155f5c",
  null
  
)

export default component.exports